import { Box, Button } from "@mui/material";

import { Cta } from "../types/ginoQuery";

/**
 * Data-driven follow-up chips. Fed by the backend's localized `result.ctas`.
 * `onCta` dispatches the chosen CTA (intent re-submit / link / download).
 * `rtl` flips chip alignment for Arabic.
 */
const FollowUpActions = ({ ctas, onCta, rtl = false }: { ctas: Cta[]; onCta: (cta: Cta) => void; rtl?: boolean }) => {
  if (!ctas?.length) return null;
  return (
    <Box
      dir={rtl ? "rtl" : "ltr"}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        mt: "4px",
        mb: "8px",
        ml: rtl ? 0 : "42px",
        mr: rtl ? "42px" : 0,
        justifyContent: rtl ? "flex-end" : "flex-start",
      }}
    >
      {ctas.map((cta, i) => (
        <Button
          key={i}
          sx={{
            padding: "6px 14px",
            background: "#f0fdf4",
            border: "1px solid #bbf7d0",
            borderRadius: "9999px",
            fontSize: 12,
            fontWeight: 600,
            fontFamily: "Montserrat",
            textTransform: "none",
            color: "#106048",
            "&:hover": { background: "#dcfce7", borderColor: "#86efac" },
          }}
          onClick={() => onCta(cta)}
        >
          {cta.label}
        </Button>
      ))}
    </Box>
  );
};

export default FollowUpActions;
